import axios from "axios";
import native from "@/common/Native";
import { Dialog } from "vant";
import store from "@/store";
import qs from "qs";

const service = axios.create({
  baseURL: process.env.VUE_APP_BASE_API,
  withCredentials: false,
  timeout: 9000
});

service.interceptors.request.use(
  config => {
    config.headers["Content-Type"] = "application/x-www-form-urlencoded";
    config.params = config.params ? config.params : {};
    const queryObj = qs.parse(location.href.split("?")[1]);
    const k = queryObj ? queryObj["k"] : "";
    if (config.method === "get") {
      if (k) {
        config.params = Object.assign(config.params, { k });
      }
    } else {
      if (k) {
        config.data = Object.assign(config.data, { k });
      }
    }
    if (config.url && config.url.includes("/video/view_count/app")) {
      config.headers["Content-Type"] = "application/json";
    } else {
      config.data = qs.stringify(config.data, { indices: false });
    }
    return config;
  },
  error => {
    return Promise.reject(error);
  }
);

service.interceptors.response.use(
  resp => {
    // 登录过期
    if (
      resp.data.code === -101000134 &&
      process.env.NODE_ENV !== "development"
    ) {
      Dialog({ message: resp.data.message }).then(() => {
        native.goForceToken().then(result => {
          store.commit("SET_STATE", result);
        });
      });
    }
    return resp.data;
  },
  error => {
    console.log("response error: ", error); // for debug
    return Promise.reject(error);
  }
);

export default service;
